module.exports = __webpack_public_path__ + "img/Overstay_Engine_Off.4d7eb937.png";